var _path, _path2, _path3, _linearGradient, _path4, _radialGradient, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamsungNoteLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-testid": "samsungNoteLandscape",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3550.2 1693.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 1688.4c0 2.8 2.2 5 5 5h435.4c2.8 0 5-2.2 5-5v-6.5H542.5v6.5zM1223.8 1689.8c0 2 1.6 3.6 3.6 3.6h229.3c2 0 3.6-1.6 3.6-3.6v-7.9h-236.6v7.9z",
    fill: "#5b5b5b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48.4v1585.1c0 26.7 21.7 48.4 48.4 48.4h16.9c-26.6 0-48.2-21.6-48.2-48.2V48.2C17.1 21.6 38.7 0 65.3 0H48.4C21.7 0 0 21.7 0 48.4zM3533.1 48.2v1585.5c0 26.6-21.6 48.2-48.2 48.2h16.9c26.7 0 48.4-21.7 48.4-48.4V48.4c0-26.7-21.7-48.4-48.4-48.4h-16.9c26.6 0 48.2 21.6 48.2 48.2z",
    fill: "#000402"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 48.2v1585.5c0 26.6 21.6 48.2 48.2 48.2h3419.6c26.6 0 48.2-21.6 48.2-48.2V48.2c0-26.6-21.6-48.2-48.2-48.2H65.3C38.7 0 17.1 21.6 17.1 48.2zm3418.4-7c13.9 0 25.1 11.3 25.1 25.1v1555c0 13.9-11.3 25.1-25.1 25.1H81.8c-13.9 0-25.1-11.2-25.1-25.1V66.4c0-13.9 11.3-25.1 25.1-25.1l3353.7-.1z",
    fill: "#000402"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "samsung_note_landscape_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 939.905,
    y1: 846.54,
    x2: 2621.775,
    y2: 846.54,
    gradientTransform: "matrix(0 -1 -1 0 2621.63 2621.79)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfc",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fcfcfc",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fcfcfc",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fcfcfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fcfcfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fcfcfc",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcfcfc",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcfcfc",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcfcfc",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fcfcfc",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1 48.2v1585.5c0 26.6 21.6 48.2 48.2 48.2h3419.6c26.6 0 48.2-21.6 48.2-48.2V48.2c0-26.6-21.6-48.2-48.2-48.2H65.3C38.7 0 17.1 21.6 17.1 48.2zm3418.4-7c13.9 0 25.1 11.3 25.1 25.1v1555c0 13.9-11.3 25.1-25.1 25.1H81.8c-13.9 0-25.1-11.2-25.1-25.1V66.4c0-13.9 11.3-25.1 25.1-25.1l3353.7-.1z",
    opacity: 0.7,
    fill: "url(#samsung_note_landscape_svg__a)"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "samsung_note_landscape_svg__b",
    cx: 1777.945,
    cy: 2485.235,
    r: 46.53,
    gradientTransform: "matrix(0 -1 -1 0 2621.63 2621.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#333a3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#1c2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#191e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#090e0e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#010505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136.4,
    cy: 843.8,
    r: 46.5,
    fill: "url(#samsung_note_landscape_svg__b)"
  })));
}
export default SvgSamsungNoteLandscape;